import { useNavigate } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

export default function FeaturedSection() {
  const navigate = useNavigate();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              精选推荐
            </h2>
            <p className="text-foreground-500 text-sm">编辑部精心挑选的优质魔法与奇幻漫画</p>
          </div>
          <a
            href="/category/magic"
            onClick={(e) => { e.preventDefault(); navigate('/category/magic'); }}
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
          {featuredComics.map((comic) => (
            <article
              key={comic.id}
              className="group cursor-pointer"
              onClick={() => navigate(`/comic/${comic.slug}`)}
            >
              <div className="relative overflow-hidden rounded-xl mb-3 aspect-[3/4]">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 非麻瓜漫画`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full">
                    {comic.status}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                  <div className="flex items-center gap-2 text-background-50 text-xs">
                    <i className="ri-star-fill text-primary-400"></i>
                    <span>{comic.rating}</span>
                    <span className="opacity-60">·</span>
                    <i className="ri-eye-line opacity-70"></i>
                    <span className="opacity-70">{(comic.views / 10000).toFixed(0)}万</span>
                  </div>
                </div>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 text-sm md:text-base group-hover:text-primary-500 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{comic.author} · {comic.categoryName}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}